import SvgDelete from '@sats-group/icons/16/delete';
import Button from '@sats-group/ui-lib/react/button';
import HiddenInput from '@sats-group/ui-lib/react/hidden-input';
import Text from '@sats-group/ui-lib/react/text';
import React, { useEffect, useRef } from 'react';
import { useRemoveMember } from '~/source/client/use-remove-member';
import { Dialog } from '../dialog/dialog';
import type { RemoveMember as Props } from './remove-member.types';

export const RemoveMember: React.FC<Props> = props => {
  const dialog = useRef<HTMLDialogElement>(null);

  const [execute, abort, isSubmitting, outcome] = useRemoveMember(
    props.dynamic.url,
    props.dynamic.data,
    {
      failure: props.copy.failure,
      success: props.copy.success,
    }
  );

  useEffect(() => {
    if (props.onOutcome) {
      props.onOutcome(outcome);
    }
  }, [outcome]);

  useEffect(() => () => abort(), []);

  const handleCompletion = () => {
    if (dialog.current) {
      dialog.current.hidePopover();
    }
  };

  const handleSubmit: React.FormEventHandler = async event => {
    event.preventDefault();
    await execute(handleCompletion);
  };

  return (
    <div className="remove-member">
      <Button
        {...props.static.trigger}
        disabled={outcome === 'SUCCESS'}
        iconOnly={props.small}
        leadingIcon={<SvgDelete />}
        popoverTarget={props.static.href}
        popoverTargetAction="toggle"
        size={props.small ? Button.sizes.small : Button.sizes.basic}
        type="button"
        variant={
          props.small
            ? Button.variants.tertiaryDestructive
            : Button.variants.secondaryDestructive
        }
      />
      <Dialog
        close={props.copy.close}
        id={props.static.href}
        ref={dialog}
        title={props.copy.title}
      >
        {props.copy.description.map(d => (
          <Text key={d}>{d}</Text>
        ))}
        <form action={props.static.href} method="post" onSubmit={handleSubmit}>
          {props.static.data.map(entry => (
            <HiddenInput {...entry} key={entry.name} />
          ))}
          <Button
            autoFocus
            disabled={isSubmitting || outcome === 'SUCCESS'}
            spinning={isSubmitting}
            text={props.copy.remove}
            type="submit"
            variant={Button.variants.primaryDestructive}
            wide
          />
        </form>
      </Dialog>
    </div>
  );
};
